import { useObserver } from '../hooks/useObserver';

export default function AnimSection({ children, style = {}, className = '', delay = 0 }) {
  const [ref, visible] = useObserver();

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity:    visible ? 1 : 0,
        transform:  visible ? 'translateY(0)' : 'translateY(28px)',
        transition: `opacity .65s ${delay}s ease, transform .65s ${delay}s ease`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
